import { NgModule } from '@angular/core';
import { ConvertDate } from './convertDate.pipe';

@NgModule({
  imports: [
    ConvertDate
  ],
  exports: [
    ConvertDate
  ]
})

export class PipeModule {
}
